module.exports = __webpack_public_path__ + "static/media/59.5f1958b9.png";